module.exports = __webpack_public_path__ + "img/VintageGearbox300x300.2ce71c59.jpg";